import { COLORS } from '../IndividualPlan/tokens';

export const DASH = {
  ink: COLORS.ink,
  muted: COLORS.muted,
  surface: COLORS.bg,
  cardBg: '#FFFFFF',
  lockedText: '#7F7F99',
  ghost: '#2A2A8B',
  rowBorder: 'rgba(8, 8, 27, 0.15)',
  trackBg: '#E3E3E8',
  greenChip: { bg: '#BBE7B1', fg: '#132B0D' },
  warnChip: { bg: '#FEE59A', dot: '#FEC620', fg: '#4D1C00' },
  stats: {
    tileBg: COLORS.bg,
    barDark: COLORS.navy,
    barPale: '#D4D4F2',
    barGrey: '#9E9EB2',
    barLabel: '#FFFFFF',
    toggleOn: '#EFEFFA',
    hover: 'rgba(8, 8, 27, 0.04)',
    bannerBg: '#EFEFFA',
    comingSoonBg: '#E8F4FD',
    comingSoonFg: '#072254',
  },
} as const;

export const WIDA_LEVELS = [
  { key: 'entering', label: 'Entering', color: '#FC8E27' },
  { key: 'emerging', label: 'Emerging', color: '#F6A55B' },
  { key: 'developing', label: 'Developing', color: '#F7C08D' },
  { key: 'expanding', label: 'Expanding', color: '#8181D9' },
  { key: 'bridging', label: 'Bridging', color: '#3A3AC5' },
  { key: 'reaching', label: 'Reaching', color: '#20206A' },
] as const;

export const CARD_SX = {
  bgcolor: DASH.cardBg,
  borderRadius: '12px',
  boxShadow:
    '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
  p: '24px',
} as const;
